import React, { useState, useMemo } from "react";
import Icon from "@ant-design/icons";
import { ReactComponent as QyWechatWhite } from "../asset/image/icon_qy_wechat_white.svg";
import { ReactComponent as QyWechat } from "../asset/image/icon_qy_wechat.svg";

export default function QYWechatOutlined({ iconClassName }) {
    const [isHover, setIsHover] = useState(false);
    const icon = useMemo(() => {
        return <Icon component={isHover ? QyWechat : QyWechatWhite} className={iconClassName} />;
    }, [isHover]);
    return (
        <div onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
            {icon}
        </div>
    );
}
